/**
 * New-doc templates (design doc §6.2, §6.9): "the template IS the
 * content-quality strategy made concrete." Headings are `##` so the
 * server's heading-based chunker (kbChunking.util.ts, splits on #/##/###)
 * produces one chunk per section.
 */
export interface KbTemplate {
  key: 'blank' | 'playbook' | 'faq' | 'policy';
  label: string;
  description: string;
  body: string;
}

export const KB_TEMPLATES: KbTemplate[] = [
  {
    key: 'blank',
    label: 'Blank',
    description: 'Start from an empty doc.',
    body: '',
  },
  {
    key: 'playbook',
    label: 'Task-flow playbook',
    description: 'Symptoms → diagnose → steps → when to escalate. Use this for most support topics.',
    body: `# New task-flow playbook

## Symptoms

What the customer sees or reports. Use their words where possible.

## Diagnose

Questions to ask or things to check before giving instructions.

## Steps

One step at a time. Tell the customer what to do, then stop and wait for the result before the next step.

## When to escalate

When to stop troubleshooting and hand off to a human / engineering / a refund path.
`,
  },
  {
    key: 'faq',
    label: 'FAQ',
    description: 'A single question and its plain-language answer.',
    body: `# New FAQ

## What customers ask

Write the customer's question here, in their own words.

## Answer

The plain-language answer. Warm, brief, no jargon.

## Related topics

Optional — links or references to other KB docs or product areas.
`,
  },
  {
    key: 'policy',
    label: 'Policy',
    description: 'A standing rule (refunds, cancellations, data requests, etc).',
    body: `# New policy

## Policy

State the policy in one or two sentences.

## Details

Explain the policy, exceptions, and how it applies.

## What to tell the customer

The customer-facing phrasing agents should use when this policy applies.
`,
  },
];
